// extracted by mini-css-extract-plugin
export var gif = "_je-0";